import React from 'react';

export default () => (
    <div className="footer-container full-test">

    </div>
);